/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/SoldAssetsTable/graphql/sold-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";


import {useAsset} from "../pages/SoldAssetsTable/provider"

const MODULE_NAME = "SoldAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class SoldAssetTableService {
    private static instance: SoldAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): SoldAssetTableService {
        if (!SoldAssetTableService.instance) {
            SoldAssetTableService.instance = new SoldAssetTableService(props);
        }
        return SoldAssetTableService.instance;
    }

    

    async getSoldAssetTable() {
        const{ id}= useAsset();
        console.log("sanm",id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        store:id,
                        offset: 0,
                        size: 5000,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getSoldAssetTable: ", res?.data?.getSoldAssetTable);
                
              
                if(res){
                    console.log("123",res?.data?.getSoldAssetTable?.data)
                    let _found = {
                        // col:res?.data?.getListedAssetTable?.data?.columnDefs,
                        // // row:[...res?.data?.getListedAssetTable?.data?.rowData,id]
                        // row:res?.data?.getListedAssetTable?.data?.rowData.map((item:any)=>{
                        //     return({
                        //         ...item,
                        //         storeId:id
                        //     })
                        // })
                        currentPage:res?.data?.getSoldAssetTable?.currentPage,
                        data:{
                            columnDefs:res?.data?.getSoldAssetTable?.data?.columnDefs,
                            // row:[...res?.data?.getListedAssetTable?.data?.rowData,id]
                            rowData:res?.data?.getSoldAssetTable?.data?.rowData.map((item:any)=>{
                                return({
                                    ...item,
                                    storeId:id
                                })
                            })
                        },
                        
                        pageSize:res?.data?.getSoldAssetTable?.pageSize,
                        totalCount:res?.data?.getSoldAssetTable?.totalCount,
                        totalPages:res?.data?.getSoldAssetTable?.totalPages
                     
                    }
                    console.log("",_found)
                    if (_found) {
                        return _found;
                    }
                }
            }
        } catch (err) {}
    }
}
